_ = require 'underscore'
makeErrorEnum = require 'lib/make-error-enum'
IFrameIO = require 'network/iframe-io'
pluginValidators = require 'lib/util/plugin-validators'
Promise = require 'bluebird'
Visibility = require 'visibilityjs'

PluginIOError = makeErrorEnum 'Plugin', [
  'NotHandled'
  'Timeout'
]

module.exports = class PluginIO
  @Error: PluginIOError

  constructor: (plugin, @handlers) ->
    @id = plugin.id
    @capabilities = plugin.get('capabilities')
    @iframeConnectorUrl = plugin.get('iframeConnectorUrl')
    @icon = plugin.get('icon')
    @listing = plugin.get('listing')
    @name = plugin.get('name')

  getName: -> @listing?.name || @name
  getDescription: -> @listing?.description || ''
  getOverview: -> @listing?.overview || ''
  getIconUrl: ->
    iconUrl = @icon?.url
    if pluginValidators.isValidUrlForImage(iconUrl)
      iconUrl
    else
      null

  _getIo: ->
    @_io ?= new IFrameIO(@iframeConnectorUrl, @handlers)

  request: (command, options, timeout) ->
    new Promise (resolve) ->
      # we only want to make a request to a Power-Up when the board is in the foreground tab
      # otherwise our communication with it is slowed so drastically by the browser that
      # we are highly prone to timing out. Also updating the information you aren't looking
      # at isn't terribly useful, so we'll just wait for you to be looking.
      Visibility.onVisible resolve
    .then =>
      @_getIo()
      .request(command, options, timeout)
      .catch IFrameIO.Error.NotHandled, ->
        throw PluginIOError.NotHandled()
      .catch IFrameIO.Error.Timeout, (err) ->
        throw PluginIOError.Timeout(err.message)

  supports: (command) ->
    _.isArray(@capabilities)? && command in @capabilities

  drop: ->
    @_getIo().then (io) ->
      io?.drop()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-io.coffee